// extracted by mini-css-extract-plugin
export default {"marker-img":"styles_marker-img__1QvUC","markerImg":"styles_marker-img__1QvUC"};